import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/free-solid-svg-icons'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import GetDataSet, {
  storelastsyncrecord,
  storesyncdataset
} from '../../../../services/data'
import { useLocation, useParams } from 'react-router-dom'

const SyncLogData = ({
  maindialogclose,
  success,
  closepopup,
  isProcessing = false
}) => {
  const [storetimestamp, setstoretimestamp] = useState('')
  const [isSyncing, setIsSyncing] = useState(false)
    const location = useLocation()
    const params = useParams()
    
      // ✅ Extract store_id from URL (params or pathname)
      const getStoreIdFromUrl = () => {
        if (params?.store_id) return params.store_id
        const pathParts = location.pathname.split('/')
        console.log(pathParts[1])
        return pathParts[1] || null
      }
    
      const storeid = getStoreIdFromUrl()

  const store_id = storeid
  const getstore = localStorage.getItem('chatbot')

  const fetchDateTimestamp = async () => {
    if (!store_id || !getstore) return
    try {
      const res = await storelastsyncrecord(store_id, getstore)
      if (res?.data?.updatedAt) {
        setstoretimestamp(res.data.updatedAt)
      }
    } catch (error) {
      console.error('Error fetching sync data:', error)
    }
  }

  // const checkTrainingStatus = async () => {
  //   try {
  //     const response = await new GetDataSet(
  //       '',
  //       '',
  //       '',
  //       '',
  //       '',
  //       '',
  //       '',
  //       1
  //     ).fetchData()
  //     const hasTraining =
  //       Array.isArray(response?.data) &&
  //       response.data.length > 0 &&
  //       response.data.some(item => item.training_processing === 1)
  //     setIsProcessing(hasTraining)
  //     window.dispatchEvent(new CustomEvent('startpolling', { detail: true }))
  //   } catch (err) {
  //     console.error('Training check error:', err)
  //     setIsProcessing(false)
  //   }
  // }

  // useEffect(()=>{
  //   checkTrainingStatus();
  // },[])

  useEffect(() => {
    if (store_id && getstore) {
      fetchDateTimestamp()
    }
  }, [])

  const handleSyncData = async () => {
    if (isSyncing || isProcessing) return

    setIsSyncing(true)

    try {
      const response = await storesyncdataset(store_id, getstore)
      // console.log('Sync Response:', response)

      if (response.success) {
        window.dispatchEvent(new CustomEvent('startpolling', { detail: true }))

        await fetchDateTimestamp()
        if (typeof success === 'function') {
          success()
          closepopup()
        }
      }
    } catch (error) {
      console.error('Error syncing data:', error)
      toast.error(
        'Sync process has failed due to an error. Please try again later.',
        {
          position: 'bottom-center',
          toastId: 'sync-failure'
        }
      )
      closepopup()
    } finally {
      setIsSyncing(false)
    }
  }

  return (
    <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
      <div className='bg-white rounded-[24px] w-[456px] min-h-[240px] border border-white shadow flex flex-col'>
        {/* Header */}
        <div className='flex justify-between items-center p-4 border-b'>
          <h2 className='font-extrabold text-[18px] leading-[30px]'>
            Sync Status
          </h2>
          <button
            className='w-[30px] h-[30px] cursor-pointer'
            onClick={maindialogclose}
          >
            <svg width='30' height='30' viewBox='0 0 30 30' fill='none'>
              <path
                d='M9.1 7.775a.9.9 0 0 0-1.325 1.325L13.675 15l-5.9 5.9a.9.9 0 1 0 1.325 1.325L15 16.325l5.9 5.9a.9.9 0 1 0 1.325-1.325L16.325 15l5.9-5.9a.9.9 0 0 0-1.325-1.325L15 13.675 9.1 7.775Z'
                fill='#373737'
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className='px-6 py-4 text-sm text-gray-700 w-full flex gap-2'>
          <p className='font-semibold text-[13.5px] text-[#252C32]'>
            Last Sync:
          </p>
          <span className='font-medium text-[13.5px] text-[#252C32]'>
            {storetimestamp
              ? new Date(storetimestamp).toLocaleString('en-US', {
                  timeZone: 'UTC'
                }) + ' (UTC)'
              : ''}
          </span>
        </div>

        {/* Footer */}
        <div className='mt-auto flex justify-end px-6 py-4 border-t'>
          <button
            onClick={() => {
              handleSyncData()
            }}
            className={`px-3 py-[12px] w-full flex justify-center items-center text-white rounded-full text-[13px] text-center ${
              isSyncing || isProcessing ? 'bg-gray-400' : 'bg-black'
            }`}
          >
            <FontAwesomeIcon icon={faSync} className='text-[11px] mr-2' />
            <span className='text-[12px] font-[700] text-center'>
              {isProcessing
                ? 'A sync is already in progress. Please wait...'
                : isSyncing
                ? 'Syncing...'
                : 'Sync Now'}
            </span>
          </button>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default SyncLogData
